import { AnimatePresence, motion } from 'framer-motion';
import { MotionContext, MotionContextProvider } from '../../context/motion-context';
import PropTypes from 'prop-types';
import React from 'react';

//

function _MotionWrapper({ children, simple, variants }) {
  const motionContent = variants?.exit_with ? (
    <AnimatePresence>{children}</AnimatePresence>
  ) : (
    children
  );

  if (!simple && variants) {
    return <MotionContextProvider {...{ variants }}>{motionContent}</MotionContextProvider>;
  }

  return motionContent;
}

Motion.propTypes = {
  children: PropTypes.node,
  simple: PropTypes.bool,
  variants: PropTypes.object,
};

//

function Motion({
  children,
  element = 'div',
  motionId,
  simple = false,
  variants,
  ...forwardedProps
}) {
  const { variants: contextVariants } = React.useContext(MotionContext) || {};

  const MotionElement = motion[element];

  //
  // Render

  return (
    <_MotionWrapper {...{ simple, variants }}>
      {children && (
        <MotionElement
          {...{
            ...forwardedProps,
            ...(variants && {
              animate: 'animate_to',
              exit: 'exit_with',
              initial: 'init_with',
            }),
          }}
          key={motionId}
          variants={variants || contextVariants}
        >
          {children}
        </MotionElement>
      )}
    </_MotionWrapper>
  );
}

Motion.propTypes = {
  children: PropTypes.node,
  element: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  simple: PropTypes.bool,
  variants: PropTypes.object,
};

// Exports

export default Motion;
